export default function SectionBlock({ eyebrow, title, description, actions, className = '', children }) {
  return (
    <section className={`surface-card ${className}`}>
      {(title || actions) ? (
        <div className="mb-4 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
          <div className="min-w-0">
            {title ? <h2 className="section-title">{title}</h2> : null}
          </div>
          {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
